export default {
    title: 'Enter Reminder Details',
    create_reminder: 'Create Reminder',
    row_title: 'Title',
    message: 'Message',
    show_reservation_time: 'Show Reservation Time in Message',
    send_before: 'Send Time Before Reservation',
    type: 'Type',
    services: 'Services',
    active: 'Active',
    action: 'Actions',
    usage: 'Usage',
    price: 'Price RSD',
    price_bam: 'Price BAM',
    chose_type: 'Choose Reminder Type',
    info_reminder_before_minutes: 'Sending time may vary by +/- 15 minutes',
    info_reminder_before_minutes_now: 'Send immediately if the reservation is less than 30 minutes away',
    show_time_example: 'Show reservation time in the message (e.g., 12.12.2024 18:00-19:00)',
    totalPrice: 'Total Usage',
    totalSmsPrice: 'SMS Usage',
    totalSmsCount: 'SMS Count',
    totalEmailPrice: 'Email Usage',
    totalEmailCount: 'Email Count',
    pdv_message: 'Prices are shown excluding VAT',
    pdv_include_message: '* VAT included',
    select_offers_msg: 'Please select services',
    select_remind_before_msg: 'Please select the time for Send Time Before Reservation',
    info_modal: {
        title: 'Reminder Information',
        text: `<h3>Service Information</h3> <p>Please pay attention to the following terms and conditions for using SMS and email reminder services:</p> <ul> <li>The cost of one SMS message is <strong>{n}</strong>.</li> <li>The total number of SMS messages depends on the number of characters in the message text.</li> <li>The character count is lower for texts in Cyrillic or Latin scripts than in the English alphabet.</li> <li>The total cost of the reminder will be displayed below the reminder message.</li> <li>The cost of sending an email is fixed at <strong>{m}</strong>.</li> <li>Every reminder must be activated by the Bookeraj team.</li> <li>You will be contacted within <strong>48 hours</strong> after creating the reminder for confirmation.</li> <li>For any questions, you can contact us at email bookeraj&#64;codebuste.rs</li> <li>The reminder sending time may vary by -15 minutes to +15 minutes relative to the selected time.</li> </ul>`,
        price: 'excluding VAT',
    },
}
